import React from 'react';
import PropTypes from 'prop-types';

import Input from '../Input/Input';
import { ReactComponent as IconSearch } from '../../assets/icon/ic_search.svg';

const SearchInput = ({
  value, onChange, isClearable, styleContainer,
  styleInput, styleInputContainer, autoFocus
}) => {
  return (
    <div className={`w-full ${styleContainer}`}>
      <Input
        isClearable={isClearable}
        leftIcon={<IconSearch className="text-text-muted" />}
        containerStyle={`mb-0 ${styleInputContainer}`}
        inputStyle={`text-[12px] p-[12px] ${styleInput}`}
        type="text"
        name="search"
        value={value}
        placeholder="Type search"
        onChange={onChange}
        autoFocus={autoFocus}
      />
    </div>
  );
};

SearchInput.propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func,
  isClearable: PropTypes.bool,
  autoFocus: PropTypes.bool,
  styleContainer: PropTypes.string,
  styleInput: PropTypes.string,
  styleInputContainer: PropTypes.string,
};

SearchInput.defaultProps = {
  onChange: () => {},
  value: '',
  isClearable: false,
  autoFocus: false,
  styleContainer: '',
  styleInput: '',
  styleInputContainer: '',
};

export default SearchInput;
